import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const LINKS = [
  { label: "About", id: "about" },
  { label: "Band", id: "band" },
  { label: "2025", id: "tour" },
  { label: "Gallery", id: "gallery" },
  { label: "Listen", id: "listen" },
  { label: "Contact", id: "contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#0a0a0b]/90 backdrop-blur-md border-b border-white/10" : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-5 sm:px-8 h-16 md:h-20 flex items-center justify-between">
        <button
          onClick={() => go("home")}
          data-testid="nav-logo"
          className="font-display text-3xl md:text-4xl leading-none tracking-wide text-white hover:text-[var(--sb-red)] transition-colors"
        >
          SONG<span className="text-[var(--sb-red)]">BIRD</span>
        </button>

        <div className="hidden md:flex items-center gap-7">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => go(l.id)}
              className="text-sm font-semibold uppercase tracking-wider text-white/75 hover:text-white transition-colors relative group"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 sb-gradient-bg group-hover:w-full transition-all duration-300" />
            </button>
          ))}
          <Button
            data-testid="nav-book-btn"
            onClick={() => go("contact")}
            className="bg-[var(--sb-red)] hover:bg-[#ff4545] text-white font-bold uppercase tracking-wider rounded-full px-6"
          >
            Book the Band
          </Button>
        </div>

        <button
          className="md:hidden text-white p-2"
          onClick={() => setOpen((o) => !o)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </nav>

      {open && (
        <div className="md:hidden bg-[#0a0a0b]/97 backdrop-blur-md border-b border-white/10 px-5 pb-6 pt-2">
          <div className="flex flex-col gap-1">
            {LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={`nav-mobile-${l.id}`}
                onClick={() => go(l.id)}
                className="text-left py-3 text-base font-semibold uppercase tracking-wider text-white/80 hover:text-[var(--sb-red)] border-b border-white/5"
              >
                {l.label}
              </button>
            ))}
            <Button
              data-testid="nav-mobile-book-btn"
              onClick={() => go("contact")}
              className="mt-4 bg-[var(--sb-red)] hover:bg-[#ff4545] text-white font-bold uppercase tracking-wider rounded-full"
            >
              Book the Band
            </Button>
          </div>
        </div>
      )}
    </header>
  );
}
